import { render } from "./HowToPlay.vue?vue&type=template&id=3106a4f0&scoped=true"
import script from "./HowToPlay.vue?vue&type=script&lang=js"
export * from "./HowToPlay.vue?vue&type=script&lang=js"

import "./HowToPlay.vue?vue&type=style&index=0&id=3106a4f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3106a4f0"]])

export default __exports__